import { formatZipCode } from "@/helpers/cep-helpers";
import { formatCurrency } from "@/helpers/currency-helpers";
import ICoverageArea from "@/interfaces/coverage-area.interface";

type UseCoverageAreaDataReturn = Partial<ICoverageArea> & {
  formattedCepStart: string;
  formattedCepEnd: string;
  formattedStartWeight: string;
  formattedEndWeight: string;
  formattedFreightChargeOrder: string;
  formattedFreightCostCarrier: string;
};

type UseCoverageAreaDataProps = {
  coverageArea: ICoverageArea | null;
};

function useCoverageAreaData({
  coverageArea,
}: UseCoverageAreaDataProps): UseCoverageAreaDataReturn {
  const formattedCepStart = formatZipCode(coverageArea?.startZipCode || "");
  const formattedCepEnd = formatZipCode(coverageArea?.endZipCode || "");
  const formattedStartWeight = (coverageArea?.startWeight ?? 0).toFixed(3).replace(".", ",");
  const formattedEndWeight = (coverageArea?.endWeight ?? 0).toFixed(3).replace(".", ",");
  const formattedFreightChargeOrder = formatCurrency(coverageArea?.freightChargeOrder || 0);
  const formattedFreightCostCarrier = formatCurrency(coverageArea?.freightCostCarrier || 0);

  return {
    ...coverageArea,
    formattedCepStart,
    formattedCepEnd,
    formattedStartWeight,
    formattedEndWeight,
    formattedFreightChargeOrder,
    formattedFreightCostCarrier,
  };
}

export default useCoverageAreaData;
